import { Suspense } from 'react';

import { dataTestIds } from 'templates/components/BannerCarousel/constants';
import { socialMediaIconsMap } from './icons';
import { SocialMediaIconProps } from './types';

const SocialMediaIcon = ({ icon, className }: SocialMediaIconProps) => {
  return (
    <Suspense fallback={null}>
      <div className={className} data-testid={dataTestIds.mediaIcon}>
        {socialMediaIconsMap[icon]}
      </div>
    </Suspense>
  );
};

export default SocialMediaIcon;
